import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck } from 'lucide-react';
export const MechanismSection = () => {
  return <SectionWrapper bg="bg-navy-800" className="relative overflow-hidden" data-id="element-70">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-71"></div>

      <div className="relative z-10 border border-gold-500/30 rounded-2xl p-8 md:p-12 bg-navy-900/50 backdrop-blur-sm shadow-[0_0_40px_rgba(201,168,76,0.05)]" data-id="element-72">
        <div className="flex justify-center mb-6" data-id="element-73">
          <div className="bg-gold-500/20 p-4 rounded-full" data-id="element-74">
            <ShieldCheck className="w-12 h-12 text-gold-500" data-id="element-75" />
          </div>
        </div>

        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-8 text-white" data-id="element-76">
          El <span className="text-gold-500" data-id="element-77">Método V.A.D.</span>
          <br className="hidden sm:block" data-id="element-78" />
          <span className="text-2xl md:text-3xl text-gray-300 font-normal" data-id="element-79">
            (Verificar, Atacar, Borrar)
          </span>
        </h2>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-80">
          <p data-id="element-81">
            Este sistema no pide favores. Utiliza la sección 611 de la ley
            federal FCRA para forzar a los burós a eliminar cualquier
            información que no puedan verificar físicamente con un contrato
            original firmado por ti.
          </p>

          <div className="bg-navy-800 p-6 rounded-lg border-l-4 border-gold-500" data-id="element-82">
            <p className="font-medium text-white text-xl" data-id="element-83">
              Si el banco o la agencia de cobranza no tiene el papel original{' '}
              <span className="text-gold-500" data-id="element-84">
                (y el 70% de las veces no lo tienen)
              </span>
              , la ley los obliga a borrar la cuenta de tu reporte en 30 días
              calendario.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};